import { IClient } from "@interfaces";
import { Card, Divider, Space } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
interface Iprops {
  loading: boolean;
  client?: IClient;
}
export const ComponentClient = ({ loading, client }: Iprops) => {
  const { t } = useTranslation();
  return (
    <StyledCard title={t("page.patient_information")} bordered={false} loading={loading}>
      <Space>
        <p>{t("page.name_label")}</p>
        <p>{client?.name}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.age_label")}</p>
        <p>{dayjs().diff(client?.dateOfBirth, "years")}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.gestational_age_label")}</p>
        <p>{client?.geastralMonth}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.number_of_childeren_label")}</p>
        <p>{client?.noOfChildren}</p>
      </Space>
      <Divider />
      <Space>
        <p>{t("page.contact_phone_number_label")}</p>
        <p>{client?.phoneNumber}</p>
      </Space>
      <Divider />
    </StyledCard>
  );
};
const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  .ant-space {
    display: flex;
    justify-content: space-between;
  }
`;
